export const actions = {
  programDetails: 'PROGRAM_FETCH_DETAILS',
  programDetailsSimple: 'PROGRAM_FETCH_DETAILS_SIMPLE',
  moreEpisodes: 'PROGRAM_FETCH_MORE-EPISODES',
  tvguide: 'FETCH_TVGUIDE',
  channels: 'FETCH_CHANNELS',
};

export const requestProgramDetails = (
  sid,
  nid,
  id,
  pid,
  start_time,
  duration,
) => ({
  type: actions.programDetails,
  sid: sid,
  nid: nid,
  id: id,
  pid: pid,
  start_time: start_time,
  duration: duration,
});

export const requestProgramDetailsSimple = (id, sid, pid) => ({
  type: actions.programDetailsSimple,
  id,
  sid,
  pid,
});

export const requestProgramMoreEpisodes = (sid, nid, id, pid) => ({
  type: actions.moreEpisodes,
  sid: sid,
  nid: nid,
  id: id,
  pid: pid,
});

export const requestFetchTvguide = (nid, start) => ({
  type: actions.tvguide,
  nid: nid,
  start: start,
});

export const requestFetchChannels = nid => ({
  type: actions.channels,
  nid: nid,
});
